export default __webpack_public_path__ + "static/media/starry-night.0cb5ddaf.jpg";